import { FC } from 'react';
import ConfigurationPresets, { TProps } from '.';
import { useChatStoreExtract } from '../../Chat/hooks/ChatStore.hooks';

type ChatStoreAwareConfigurationPresetsProps = Pick<TProps, 'title' | 'readOnly' | 'onlyStarred'>;

export const ChatStoreAwareConfigurationPresets: FC<
  ChatStoreAwareConfigurationPresetsProps
> = props => {
  const config = useChatStoreExtract(state => state.config);
  const responses = useChatStoreExtract(state => state.responses);
  const setConfig = useChatStoreExtract(state => state.setConfig);
  const setResponses = useChatStoreExtract(state => state.setResponses);
  return (
    <ConfigurationPresets
      config={config}
      responses={responses}
      setConfig={setConfig}
      setResponses={setResponses}
      {...props}
    />
  );
};
